import {Button, styled} from '@mui/material';

const StyledButton = styled(Button)`
	border-radius: 4px;
	width: 100%;
	min-width: 100%;
	font-size: 16px;
	font-weight: 600;
`;

export {StyledButton};
